import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RentalInfo, ObjectTypeInfo, ComponentBase, PriceModel, RentalStatus, UIService, DibsPaymentType, DiscountModel, IntervalPrice, ResultDetailLevel, OrderCustomerModel, CustomerInfo } from 't4core';
import * as moment from 'moment';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatDialog } from '@angular/material/dialog';
import { RentalAgreementComponent } from '../../dialogs/rental-agreement/rental-agreement.component';
import { BookingService } from 'app-components';
import { UntypedFormControl } from '@angular/forms';
import { AddonPopupComponent } from '../../dialogs/addon-popup/addon-popup.component';
import { LayoutService, NavigationService } from 'app-components';
import { ObjectTypeInfoWithIntervalPrice } from '../../../../lib/Models/ObjectTypeInfoWithIntervalPrice';
import { RentalObjectInfo } from '../../../../../projects/t4core/src/public-api';


@Component({
    selector: 'app-booking-summary',
    templateUrl: './booking-summary.component.html',
    standalone: false
})
export class BookingSummaryComponent extends ComponentBase implements OnInit {
  @Input() public booking: RentalInfo;
  @Output() public bookingChange = new EventEmitter<RentalInfo>();
  @Input() public confirmed = false;
  @Input() public atLocation = false;
  @Input() public editingExistingBooking: boolean = false;
  showDiscount: boolean = false;
  @Input()
  set addonsFromPopup(value: ObjectTypeInfo[]) {
    this.addedProductChangedFromPopup(value);
  }
  @Output() sendNext = new EventEmitter<boolean>();
  @Output() changeSavedCard = new EventEmitter<boolean>();
  @Output() changeTerms = new EventEmitter<boolean>();
  @Output() changePrice = new EventEmitter<PriceModel>();
  @Output() specialConditionChanged = new EventEmitter<boolean>();
  @Output() termsAndConditionCheckedChanged = new EventEmitter<boolean>();

  public addons: ObjectTypeInfoWithIntervalPrice[];
  public addedPriceProds: ObjectTypeInfo[] = [];
  public showAddonInfo: boolean[] = [];
  @Output() addableTypesChanged = new EventEmitter<ObjectTypeInfo[]>();
  public isAddedProductsChanged: Boolean = false;
  public currentPrice: PriceModel = new PriceModel();
  public savedCardAvailable = false;
  public savedCard = false;
  public terms = false; 
  public rentalStatus = RentalStatus;
  //public paymentType: number;
  public dibsPayment = DibsPaymentType;
  public rentalAgreement: string;
  public mapLink: string;
  public typeImage: string;
  public discountCode: string = "";
  public incorrectDiscount: boolean = false;
  public discount: DiscountModel = null;

  public rentalPeriodText: string;
  public addedPriceProdsTranslations: string[] = [];
  public discountControl = new UntypedFormControl('');
  public shownAddons: ObjectTypeInfo[];

  public extraConditionExist: boolean = false;
  public specialConditionChecked: boolean = false;
  public termsAndConditionchecked: boolean = false;
  public showNoInsuranceMsg: boolean = false;
  /*public removedProducts: ObjectTypeInfo[] = [];*/

  public discountLoading: boolean = false;
  public specificObject: RentalObjectInfo;
  public showSpecificObject: boolean = false;

  public originalAddedProducts: any = [];

  public get offerCreated(): boolean {
    return this.bookingService.offerCreated;
  }
  constructor(private TheUI: UIService, private appService: AppIntegrationService, public dialog: MatDialog, public bookingService: BookingService, private layoutService: LayoutService, private appSettings: AppSettingsService, private navigationService: NavigationService) {
    super();
  }

  async ngOnInit(): Promise<void> {
    if (this.booking && this.booking.PickupLocation) {
      //this.typeImage = "https://turbo3.brenderuprental.com/Handlers/RentalObjectTypePictureHandler.ashx?k=" + this.booking.PickupLocation.RentalLocationGroupId + "&n=" + this.booking.PrimaryType.Id + "&t="
      this.typeImage = this.booking.PrimaryType.PictureUri;
    }
    else {
      this.typeImage = this.booking.PrimaryType.PictureUri;
    }

    const varebilPrimaryObjectTypes = [657, 873, 874, 876, 933, 950, 415, 1088];

    if (varebilPrimaryObjectTypes.includes(this.booking.PrimaryObjectTypeId))
      this.rentalPeriodText = await this.Translate.translate('Intellitrailer.Booking.UnConfirmedBooking.RentVarebil', 'Rent');
    else
     this.rentalPeriodText = await this.Translate.translate('Intellitrailer.Booking.UnConfirmedBooking.Rent', 'Rent');

    var token = this.UI.beginLoading("Intellitrailer.Booking.BookingSummary.msgLoading", "Checking availability", null);
    this.rentalAgreement = await this.Api.get<string>("Settings/GetAgreementText");
    await this.updateAddableProducts();
    await this.addDiscount();
    await this.checkForSavedCard();
    //this.paymentType = await this.getDibsPaymentType();
    
    if (this.booking.PrimaryType.SpecialCondition) {
      this.extraConditionExist = true;
    }

    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);

    if (iOS) {
      this.mapLink = 'http://maps.apple.com/?q=' + this.booking.PickupLocation.Latitude + "," + this.booking.PickupLocation.Longitude;
    }
    else {
      this.mapLink = "https://maps.google.com/?q=" + this.booking.PickupLocation.Latitude + "," + this.booking.PickupLocation.Longitude;
    }

    if (this.booking.DiscountId) this.showDiscount = true;
    this.UI.loaderCompleted(token);
    this.getSpecificObject();
  }

  //public async getDibsPaymentType(): Promise<number> {
  //    return await this.Api.get<any>("/Settings/getDibsPaymentType");
  //}

  public async updateAddableProducts() {
    this.addons = await this.Api.get<ObjectTypeInfo[]>("/RentalObject/App/GetAddons", { typeId: this.booking.PrimaryType.Id, locationId: this.booking.PickupLocationId }, null, null, ResultDetailLevel.Slim);
    for (let type of this.addons) {
      this.showAddonInfo.push(false);
    }
    this.addableTypesChanged.emit(this.addons);
    this.shownAddons = this.addons.filter(x => x.IsHidden === false);
    this.updateAddedProducts();
  }

    public async addedProductChangedFromPopup(products: ObjectTypeInfo[], goNext = true) {
        if (!products) return;

        for (let product of products) {
            var index = this.addons.findIndex(x => x.Id == product.Id);
            if (index > -1) {
              var e = new MatSlideToggleChange(null, product.IsSelected);
              await this.addedProductChanged(this.addons[index], e.checked);
            }
        }

        if (goNext) this.sendNextToParent();
    }

    public sendNextToParent() {
        this.sendNext.emit(true);
    }

    public async openMaps(url: string) {
        this.appService.openExternal(url);
  }

  public async addedProductChanged(product: ObjectTypeInfo, add: boolean) {
        if (add) {
            this.addAddedProduct(product);
        } else {

          if (product.AskIfNotSelected) {
            const dialogRef = this.dialog.open(AddonPopupComponent, {
              disableClose: true,
              width: '350px',
              position: { top: '100px' },
              data: { product: product, booking: this.booking, confirmed: this.confirmed }
            });

            var result = await dialogRef.afterClosed().toPromise();
            if (result == true) {
              product.IsSelected = true;
              return;
            }
          }

            this.removeAddedProduct(product);
    }
        //await this.updatePrice();
        this.isAddedProductsChanged = true;
        this.bookingChange.emit(this.booking);
        this.addableTypesChanged.emit(this.addons);
  }


    private async updateAddedProducts() {
        var firstLoad: boolean = this.booking.AddedProducts == null ? true : false;
        if (!this.booking.AddedProducts) this.booking.AddedProducts = "";
        if (!this.booking.AddedProductIds) this.booking.AddedProductIds = [];

        if (firstLoad) {
            for (var i of this.addons) {
                if (i.IsDefault) {
                    this.addAddedProduct(i);
                    this.isAddedProductsChanged = true;
                }
            }
        } else {
            for (var t of this.booking.AddedProductIds) {
                var p = this.addons.find(x => x.Id == t);
                if (p) this.addAddedProduct(p);
                else {
                    if (this.booking.AddedProductIds.indexOf(t) >= 0) this.booking.AddedProductIds.splice(this.booking.AddedProductIds.indexOf(t));
                    this.booking.AddedProducts = this.booking.AddedProducts.replace(t + ";", "");

                    // Replacement?
                    var replacement = this.addons.find(x => x.ReplacementFor && x.ReplacementFor.indexOf(t + ";") >= 0);
                    if (replacement) this.addAddedProduct(replacement);
                }
            }
        }

        await this.updatePrice();
    }

  private addAddedProduct(product: ObjectTypeInfo) {
      if (this.booking.AddedProducts.indexOf(product.Id + ";") < 0) {
          this.booking.AddedProducts += product.Id + ";";
          this.booking.AddedProductIds.push(product.Id);
      }

      product.IsSelected = true;
      if (product.Id == 1004 || product.Id == 901) {
/*          if (this.removedProducts.indexOf(product) >= 0) this.removedProducts.splice(this.removedProducts.indexOf(product), 1);*/
        this.showNoInsuranceMsg = false;
      } 

      for (var i of this.addons) {
          if (i.Id == product.Id || !i.IsSelected) continue;
          if (i.CheckCondition && eval(i.CheckCondition) !== true) {
              this.removeAddedProduct(i);
          }
    }

      if (this.originalAddedProducts.length == 0) return;
      const original = this.originalAddedProducts.find(p => p.ArticleNo == product.Id);
      if (original) {
        this.currentPrice.AddedProducts.push(original);
        this.currentPrice.DiscountedTotalPrice += original.Price;
        this.currentPrice.TotalPrice += original.Price;
        this.currentPrice.ToPay += original.Price;
        this.currentPrice.DiscountableTotalPrice += original.Price;
      }
    }

    private removeAddedProduct(product: ObjectTypeInfo) {
        product.IsSelected = false;
      if (product.Id == 1004 || product.Id == 901) {
          this.showNoInsuranceMsg = true;
/*          this.removedProducts.push(product);*/
        }
        this.booking.AddedProducts = this.booking.AddedProducts.replace(product.Id + ";", "");
      if (this.booking.AddedProductIds.indexOf(product.Id) >= 0) this.booking.AddedProductIds.splice(this.booking.AddedProductIds.indexOf(product.Id), 1);

      //update rental price locally
      if (this.originalAddedProducts.length == 0) return;
      if (!this.currentPrice.AddedProducts) return;
      const removedAddedProduct = this.currentPrice.AddedProducts.find(p => p.ArticleNo == product.Id);
      this.currentPrice.DiscountedTotalPrice -= removedAddedProduct.Price;
      this.currentPrice.TotalPrice -= removedAddedProduct.Price;
      this.currentPrice.ToPay -= removedAddedProduct.Price;
      this.currentPrice.DiscountableTotalPrice -= removedAddedProduct.Price;
      this.currentPrice.AddedProducts = this.currentPrice.AddedProducts.filter(p => p.ArticleNo !== product.Id);
      console.log("removedAddedProduct", this.currentPrice);
      this.changePrice.emit(this.currentPrice);
    }

   

    public async updatePrice() {
      //var token = this.UI.beginLoading("Intellitrailer.Booking.BookingSummary.msgUpdatingCurrentPrice", "Updating Current Price", null);
      var thirtyMinsFromNow = moment().add(30, 'minutes');
      var webBooking = true;//!this.atLocation;

      if (!webBooking && this.booking.PickupTime >= thirtyMinsFromNow) {
        webBooking = true;
      }
      var currentCoordinates = await this.appService.getCoordinates();
      if (this._isDestroyed) return;

        this.currentPrice = await this.Api.get<PriceModel>("/Price/GetRentalPrice",
            {
                pickupTime: this.booking.PickupTime ? this.booking.PickupTime.toISOString() : moment().toISOString(),
                returnTime: this.booking.ReturnTime.toISOString(),
                objectTypeId: this.booking.PrimaryObjectTypeId,
                pickupLocationId: this.booking.PickupLocation.Id,
                returnLocationId: this.booking.ReturnLocation ? this.booking.ReturnLocation.Id : this.booking.PickupLocation.Id,
                useInsurance: false,
                webBooking: await this.bookingService.isWebBooking(),
                actualReturnTime: this.booking.ReturnedAt ? this.booking.ReturnedAt.toISOString() : (this.booking.Status == RentalStatus.Late ? moment().toDate().toISOString() : this.booking.ReturnTime.toISOString()),
                createdAt: this.booking.CreatedAt ? this.booking.CreatedAt.toISOString() : moment().toDate().toISOString(),
                discountId: this.booking.DiscountId,
                addedProducts: this.booking.AddedProducts,                
                bookingLat: currentCoordinates ? currentCoordinates.Latitude : null,
                bookingLng: currentCoordinates ? currentCoordinates.Longitude : null
          });

        this.originalAddedProducts = this.currentPrice.AddedProducts.map(p => ({ ...p }));
        console.log("originalAddedProducts", this.originalAddedProducts);
        this.changePrice.emit(this.currentPrice);


        for (let prod of this.addons) {
            if (this.currentPrice.AddedProducts.find(x => x.ArticleNo == prod.Id)) {
                this.addedPriceProds.push(prod);
            }
        }

        for (let prod of this.currentPrice.AddedProducts) {
            if (prod.Name.indexOf('Turbo.') == 0) {
                var translation = await this.Translate.translate(prod.Name);
                translation = translation.replace(" (", "<br> (")
                this.addedPriceProdsTranslations.push(translation);
            }
            else this.addedPriceProdsTranslations.push("");
      }
      //this.UI.loaderCompleted(token);
    }

    public async checkForSavedCard() {
      //var user = this.appSettings.userId;
      //  if (user) {
      //    var customer = await this.Api.get<any>("/Rental/FindCustomerByUser");
      //    if (customer) {
      //      this.savedCardAvailable = customer.HasDibsTicket;
      //      this.savedCard = customer.HasDibsTicket;
      //    }
      //  }
    }

    public savedCardToggle(event: MatSlideToggleChange) {
        this.savedCard = event.checked;
        this.changeSavedCard.emit(this.savedCard);
    }
     
  public termsToggle(event: MatSlideToggleChange) {
        this.terms = event.checked;
        this.changeTerms.emit(this.terms);
    }
     

  public sendSpecialConditionToParent(event) {
    this.specialConditionChecked = event.checked;
    this.specialConditionChanged.emit(this.specialConditionChecked)
  }
   
    public async showTerms() {
      // SPECIAL CASE //
      const varebilPrimaryObjectTypes = [657, 873, 874, 876, 933, 950, 415, 1088];

      if (varebilPrimaryObjectTypes.includes(this.booking.PrimaryObjectTypeId)){
        const dialogRef = this.dialog.open(RentalAgreementComponent, { data: { agreementType: "bauhausVarebil" } });
      }
      else {
        const dialogRef = this.dialog.open(RentalAgreementComponent, { data: { agreementType: "booking", rentalAgreement: this.rentalAgreement } });
      }

    }
     
    public togglAddonInfo(k: number) {
        this.showAddonInfo[k] = !this.showAddonInfo[k];
    }

    public async showInfo(type, title = null, key: string = null, cost: any = null) {
        //const dialogRef = this.dialog.open(RentalAgreementComponent, { data: { agreementType: "info", title: "Intellitrailer.Booking.BookingSummary.BookingFeeInfoTtl", key: "Intellitrailer.Booking.BookingSummary.BookingFeeInfoMsg"  } });
        if (type == 'bookingFee') {
            const dialogRef = this.dialog.open(RentalAgreementComponent, { data: { agreementType: "info", title: "Intellitrailer.Booking.BookingSummary.BookingFeeInfoTtl", key: "Intellitrailer.Booking.BookingSummary.BookingFeeInfoMsg" } });
        }
        else {
            const dialogRef = this.dialog.open(RentalAgreementComponent, { data: { agreementType: "info", title: title, key: key} });

        }
    }

  public async showDiscountCard() {
    this.showDiscount = true;
  }  

  public async addDiscount() {
    var token = this.TheUI.beginLoading("Intellitrailer.Booking.BookingSummary.msgLoadingOptions", "Loading booking data", null);

    this.discountLoading = true;

    var discountLoadedFromBooking = this.booking.DiscountId && this.booking.DiscountId.length > 0;
    this.discountCode = discountLoadedFromBooking ? this.booking.DiscountId : this.discountCode;

    if (this.discountCode && this.discountCode.length > 0) {
     
      this.discountCode = this.discountCode.trim();
    
      this.discount = await this.Api.get<DiscountModel>("Price/App/ValidateDiscount", {
        code: this.discountCode,
        pickupTime: this.booking.PickupTime,
        returnTime: this.booking.ReturnTime,
        pickupLocationId: this.booking.PickupLocation.Id,
        returnLocationId: this.booking.ReturnLocation ? this.booking.ReturnLocation.Id : this.booking.PickupLocation.Id,
        objectTypeId: this.booking.PrimaryType.Id,
        createdAt: this.booking.CreatedAt ? this.booking.CreatedAt : moment().format(),
        isWebBooking: await this.bookingService.isWebBooking(),
        isOneWay: false,
        newRequest: true,
        addedProducts: this.booking.AddedProducts
      }, null, null, ResultDetailLevel.Basic);
      if (this.discount && (!this.discount.IsEmpty || this.discount.IsInviteFriendsCampaign)) {
        this.booking.DiscountId = this.discountCode;
        this.updatePrice();
        this.incorrectDiscount = false;
        this.discountControl.setErrors({ 'incorrect': false });
        this.UI.loaderCompleted(token);
        if (!discountLoadedFromBooking) this.UI.alert("Intellitrailer.Booking.BookingSummary.DiscountAddedTtl", "Discount added!", "Intellitrailer.Booking.BookingSummary.DiscountAddedMsg", "The discount has been added to your booking.");
        this.discountLoading = false;
        return;
      }
    }

    this.incorrectDiscount = true;
    this.discountControl.setErrors({ 'incorrect': true });
    this.booking.DiscountId = "";
    this.UI.loaderCompleted(token);

    this.discountLoading = false;
  }

  public async removeDiscount() {
    this.booking.DiscountId = "";
    this.discountCode = "";
    this.updatePrice();
  }

  get trimmedComment(): string {
    return this.discount?.Comment?.replace(/<[^>]*>/g, '') || '';
  }
  public chooseSpecificTrailer() {
    this.navigationService.executeCommand("ChooseSpecificTrailer");
  }

  public async getSpecificObject() {
    const storedObject = this.bookingService.getSpecificObject();
    if (storedObject) {
      this.specificObject = storedObject;
    } else {
      var currentCoordinates = await this.appService.getCoordinates();

      this.specificObject = await this.Api.get<RentalObjectInfo>("RentalObject/App/GetSpecificObject",
        {
          locationId: this.booking.PickupLocationId,
          typeId: this.booking.PrimaryObjectTypeId,
          pickupTime: this.booking.PickupTime.clone().toISOString(),
          returnTime: this.booking.ReturnTime.clone().toISOString(),
          bookingLat: currentCoordinates ? currentCoordinates.Latitude : null,
          bookingLng: currentCoordinates ? currentCoordinates.Longitude : null,
          isOneway: this.appSettings.IsOneWay
        });

      if (this.specificObject) {
        this.bookingService.setSpecificObject(this.specificObject);
      }
    }    
  }
}
